import { createElement, HTMLAttributes, JSX } from 'react';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

type SanitizedHtmlTag = Extract<keyof JSX.IntrinsicElements, string>;

type SanitizedHtmlProps = {
	html: string;
	as?: SanitizedHtmlTag;
} & Omit<HTMLAttributes<HTMLElement>, 'dangerouslySetInnerHTML' | 'children'>;

const SanitizedHtml = ({ html, as = 'div', ...props }: SanitizedHtmlProps) => {
	const sanitizedHtml = sanitizeHtml(html);

	return createElement(as, {
		...props,
		dangerouslySetInnerHTML: { __html: sanitizedHtml },
	});
};

export default SanitizedHtml;
